import {
    ApplicationCreationForm,
    ApplicationDTO,
    ApplicationSimpleResponse,
} from "../domain/models/dto/ApplicationDTO";
import { CollectionResponse } from "../types/ApiResults";
import { PaginationParams } from "../types/PaginationParams";
import { ApiServiceImpl, createAsyncThunkFactory } from "./ApiServiceImpl";

export class ApplicationServiceImpl extends ApiServiceImpl {
    private constructor() {
        super();
    }

    static createApplicationThunk = createAsyncThunkFactory<
        ApplicationDTO,
        ApplicationCreationForm
    >("ApplicationServiceImpl.createApplication", async (args) => {
        return this.post("/api/v1/application", args);
    });

    static approveApplicationThunk = createAsyncThunkFactory<
        ApplicationDTO,
        { id: string }
    >("ApplicationServiceImpl.approveApplication", async (args) => {
        return this.patch(`/api/v1/application/${args.id}/approve`, {});
    });

    static declineApplicationThunk = createAsyncThunkFactory<
        ApplicationDTO,
        { id: string }
    >("ApplicationServiceImpl.declineApplication", async (args) => {
        return this.patch(`/api/v1/application/${args.id}/decline`, {});
    });

    static updateApplicationThunk = createAsyncThunkFactory<
        ApplicationDTO,
        ApplicationCreationForm
    >("ApplicationServiceImpl.updateApplication", async (args) => {
        return this.patch(`/api/v1/application`, args);
    });

    static deleteApplicationThunk = createAsyncThunkFactory<
        ApplicationSimpleResponse,
        { id: string }
    >("ApplicationServiceImpl.deleteApplication", async (args) => {
        return this.delete(`/api/v1/application/${args.id}`);
    });

    static getWorkApplicationsThunk = createAsyncThunkFactory<
        CollectionResponse<ApplicationDTO>,
        { params: PaginationParams; workId: string }
    >("ApplicationServiceImpl.getWorkApplications", async (args) => {
        return this.getCollection("/api/v1/application", {
            ...args.params,
            workId: args.workId,
        });
    });
}
